export const STATUS_TYPES = {
    DRAFT: 'draft',
    REVIEW: 'review',
    SCHEDULED: 'scheduled',
    ACTIVE: 'active',
    DISABLED: 'disabled',
    COMPLETED: 'completed',
    PAUSED: 'paused',
};

export const STATUS_ORDER = {
    [STATUS_TYPES.ACTIVE]: 1,
    [STATUS_TYPES.PAUSED]: 2,
    [STATUS_TYPES.REVIEW]: 3,
    [STATUS_TYPES.SCHEDULED]: 4,
    [STATUS_TYPES.DRAFT]: 5,
    [STATUS_TYPES.COMPLETED]: 6,
    [STATUS_TYPES.DISABLED]: 7,
};

/* eslint-disable internal-rules/no-hardcoded-colors */
export const STATUS_COLOR_MAP = {
    [STATUS_TYPES.DRAFT]: 'blue',
    [STATUS_TYPES.REVIEW]: 'teal',
    [STATUS_TYPES.SCHEDULED]: 'orange',
    [STATUS_TYPES.ACTIVE]: 'green',
    [STATUS_TYPES.DISABLED]: 'gray',
    [STATUS_TYPES.COMPLETED]: 'gray',
    [STATUS_TYPES.PAUSED]: 'yellow',
};
/* eslint-enable internal-rules/no-hardcoded-colors */

export const OPTIONS = {
    [STATUS_TYPES.DRAFT]: {
        label: 'Draft',
        state: 'draft',
    },
    [STATUS_TYPES.REVIEW]: {
        label: 'Pending review',
        state: 'review',
    },
    [STATUS_TYPES.SCHEDULED]: {
        label: 'Scheduled',
        state: 'scheduled',
    },
    [STATUS_TYPES.ACTIVE]: {
        label: 'Active',
        state: 'active',
    },
    [STATUS_TYPES.DISABLED]: {
        label: 'Disabled',
        state: 'disabled',
    },
    [STATUS_TYPES.COMPLETED]: {
        label: 'Completed',
        state: 'completed',
    },
    [STATUS_TYPES.PAUSED]: {
        label: 'Paused',
        state: 'paused',
    },
};
